export default "__VITE_ASSET__BelCCKTn__"